export default "__VITE_ASSET__5df1e353__"